import { useMutation, useQuery } from 'react-apollo';

import { MeQuery } from '../../../../../../../graphql/queries/account';
import { getSimplifiedAlbumMembershipGroupQuery } from '../../../../../../temp/views/memberships/AlbumMembershipGroup/graphql/queries/getSimplifiedAlbumMembershipGroup';
import { albumFolderJoin as albumFolderJoinMutation } from '../../../../../../../graphql/mutations/album-folder';
import { albumsJoinByCode as albumsJoinByCodeMutation } from '../../../../../../../graphql/mutations/albums';
import { AlbumFolderWithPurchasableItems } from '../../../../../../../graphql/queries/album-folder';

const useAutoJoinNullState = ({ rootAlbumFolderId, hierarchyItemId }) => {
  const { data: { me } = {}, loading: loadingUser } = useQuery(MeQuery);

  const {
    data: { albumMembershipGroup } = {},
    loading: loadingAlbumMembershipGroup,
  } = useQuery(getSimplifiedAlbumMembershipGroupQuery, {
    variables: {
      id: hierarchyItemId,
    },
    fetchPolicy: 'cache-first',
    skip: !hierarchyItemId,
  });

  const { data: { albumFolder } = {} } = useQuery(
    AlbumFolderWithPurchasableItems,
    {
      variables: {
        id: rootAlbumFolderId,
      },
      skip: !rootAlbumFolderId,
    },
  );

  const [onAlbumFolderJoin] = useMutation(albumFolderJoinMutation);
  const [onAlbumsJoinByCode] = useMutation(albumsJoinByCodeMutation);

  const albumFolderJoin = async ({ album_folder_id, identity_ids }) => {
    const result = onAlbumFolderJoin({
      variables: {
        input: {
          album_folder_id,
          identity_ids,
          sync_album_joins: true,
        },
      },
      refetchQueries: [
        {
          query: getSimplifiedAlbumMembershipGroupQuery,
          variables: {
            id: hierarchyItemId,
          },
        },
      ],
    });

    return result;
  };

  const albumsJoinByCode = async ({ account_id, join_codes, identities }) => {
    const result = onAlbumsJoinByCode({
      variables: {
        input: {
          account_id,
          join_codes,
          identities,
        },
      },
      refetchQueries: [
        {
          query: getSimplifiedAlbumMembershipGroupQuery,
          variables: {
            id: hierarchyItemId,
          },
        },
      ],
    });

    return result;
  };

  return {
    user: me,
    loadingUser,
    albumMembershipGroup,
    loadingAlbumMembershipGroup,
    hasPrepaidPrintPackages:
      albumFolder?.picture_day_enabled &&
      albumFolder?.prepaid_print_packages_enabled &&
      albumFolder?.album_folder_print_packages?.total > 0,
    activePromoCode: albumFolder?.active_promo_codes?.records?.[0],
    albumFolderJoin,
    albumsJoinByCode,
  };
};

export default useAutoJoinNullState;
